import PostApiBase from "@/modules/post/services/ApiBase"
import {axios as http} from "@/plugins/http";

export default class Api {
    static addImage(q) {
        return PostApiBase.siteAddImage(q).then((resp) => {
            return resp.data["item"]
        })
    }
    static deleteImage(q) {
        return PostApiBase.deleteImage(q).then((resp) => {
            return resp.data
        })
    }
    static crop(q) {
        return http.post("/api/v1/post/image-crop", q)
    }
}